import { useState } from "react";
import "./PopupUserInfo.css";

const PopupUserInfo = () => {
  const [next, setNext] = useState("");

  const handleNext = () => {
    if (next === "") {
      setNext("Parental Consent");
    }
    if (next === "Parental Consent") {
      setNext("Close popup");
    }
  };

  return (
    next !== "Close popup" && (
      <div className="popupUserInfo">
        <div
          className={`popupUserInfo__container ${
            next === "Parental Consent" && "parental-consent"
          } flex-row`}
        >
          <section className="popupUserInfo__leftSection flex-column">
            <img
              src={
                next === "Parental Consent"
                  ? "https://gist.githubusercontent.com/faustabmnyh/070481fe272d83fc3cc0cd704121a794/raw/d9e247b4c6a4c9bc2a67d8becaba7e4d7219819b/shield-protection.svg"
                  : "https://gist.githubusercontent.com/faustabmnyh/070481fe272d83fc3cc0cd704121a794/raw/b8cb8909894f1d6b050f59ace8aabf18613e7e78/avatar2.svg"
              }
              alt="geniusparkle avatar"
            />
            <div className="popupUserInfo__leftSectionText flex-column">
              <h1>
                {next === "Parental Consent"
                  ? "Parental Consent Needed"
                  : "Let's get you set up"}
              </h1>
              <span>It should take a couple of minutes</span>
            </div>
            <span
              className="popupUserInfo__btnArrow rounded"
              onClick={handleNext}
            >
              <svg viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.47992 7.24977C8.47992 6.98977 8.38993 6.72977 8.18993 6.52977L2.05993 0.309766C1.66993 -0.0902344 1.03992 -0.0902344 0.649922 0.309766C0.259922 0.709766 0.259922 1.34976 0.649922 1.73976L6.07993 7.24977L0.649922 12.7598C0.259922 13.1498 0.259922 13.7998 0.649922 14.1898C1.03992 14.5898 1.66993 14.5898 2.05993 14.1898L8.18993 7.96977C8.38993 7.76977 8.47992 7.50977 8.47992 7.24977Z" />
              </svg>
            </span>
          </section>
          <section className="popupUserInfo__rightSection flex-column">
            {next === "Parental Consent" ? (
              <p className="popupUserInfo__rightSectionParentalConsent">
                Since you’re under 13, we need your parent to review our privacy
                policy and consent on behalf of you.
                <br />
                <br />
                If you can’t get your parent to consent on behalf of you within
                next 24 hours, we’ll delete your account and personal
                information from our database.
                <br />
                <br />
                If you’re the parent, then click on the message button that just
                appeared, type “ZOOM” and send. Then our customer support team
                will send you a zoom meeting link through which you can verify
                you’re the parent and consent on behalf of your child.
              </p>
            ) : (
              <>
                <div className="flex-row">
                  <label htmlFor="user-username">Username</label>
                  <input type="text" placeholder="Enter your username" />
                </div>
                <div className="popupUserInfo__rightSectionGender flex-row">
                  <label htmlFor="user-gender">Gender</label>
                  <div className="flex-row">
                    <label htmlFor="user-gender-male" className="flex-row">
                      <input
                        type="radio"
                        id="user-gender-male"
                        name="user-gender"
                      />
                      <span className="popupUserInfo__rightSectionIconContainer">
                        <img
                          src="https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/3d90217f1232529ca593244c5ec05a6c2657d23c/male.svg"
                          alt="male"
                        />
                      </span>
                      Male
                    </label>
                    <label htmlFor="user-gender-female" className="flex-row">
                      <input
                        type="radio"
                        id="user-gender-female"
                        name="user-gender"
                      />
                      <span className="popupUserInfo__rightSectionIconContainer">
                        <img
                          src="https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/3d90217f1232529ca593244c5ec05a6c2657d23c/male.svg"
                          alt="female"
                        />
                      </span>
                      Female
                    </label>
                  </div>
                </div>
                <div className="flex-row">
                  <label htmlFor="user-username">Your Age</label>
                  <input type="text" placeholder="How old are you?" />
                </div>
                <div className="flex-row">
                  <label htmlFor="user-username">Language</label>
                  <input type="text" placeholder="Languages you know" />
                </div>
                <div className="flex-row">
                  <label htmlFor="user-username">Language</label>
                  <input
                    type="text"
                    placeholder="Languages you're interested in"
                  />
                </div>
                <div className="flex-row">
                  <label htmlFor="user-username">Language</label>
                  <input type="text" placeholder="Languages you know" />
                </div>
                <div className="flex-row">
                  <label htmlFor="user-username">Country</label>
                  <input type="text" placeholder="Enter your country name" />
                </div>
                <div className="popupUserInfo__rightSectionIdentity flex-row">
                  <label htmlFor="user-identity">Identity</label>
                  <div className="flex-row">
                    <label htmlFor="user-identity-student" className="flex-row">
                      <input
                        type="radio"
                        id="user-identity-student"
                        name="user-identity"
                      />
                      <span className="popupUserInfo__rightSectionIconContainer">
                        <img
                          src="https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/63395cbbc2fa2d5c9689dbdf70c06dc6a1ce4e06/avatar.svg"
                          alt="avatar"
                        />
                      </span>
                      Student
                    </label>
                    <label htmlFor="user-identity-teacher" className="flex-row">
                      <input
                        type="radio"
                        id="user-identity-teacher"
                        name="user-identity"
                      />
                      <span className="popupUserInfo__rightSectionIconContainer">
                        <img
                          src="https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/63395cbbc2fa2d5c9689dbdf70c06dc6a1ce4e06/avatar.svg"
                          alt="avatar"
                        />
                      </span>
                      Teacher
                    </label>
                    <label htmlFor="user-identity-parent" className="flex-row">
                      <input
                        type="radio"
                        id="user-identity-parent"
                        name="user-identity"
                      />
                      <span className="popupUserInfo__rightSectionIconContainer">
                        <img
                          src="https://gist.githubusercontent.com/faustabmnyh/62245f19337b13c5195999e7acbb525d/raw/63395cbbc2fa2d5c9689dbdf70c06dc6a1ce4e06/avatar.svg"
                          alt="avatar"
                        />
                      </span>
                      Parent
                    </label>
                  </div>
                </div>
              </>
            )}
          </section>
        </div>
      </div>
    )
  );
};

export default PopupUserInfo;
